import ListItemRadioGroup from "components/item-radio-group"
import { FILTER_SCOPE, FILTER_SCOPE_LABELS } from "helpers/filter-scope"
import { BASE_TYPES, BASKET_TYPES } from "helpers/base"

export const FILTER_SCOPE_INACTIVE_CAPTION = "Applies when a benchmark is selected."
export const FILTER_SCOPE_UNAVAILABLE_TOOLTIP = "Not available"
export const FILTER_SCOPE_LOCKED_BY_TAG_ON_BENCHMARK_CAPTION = "Your benchmark has no tags, so this filter applies to the portfolio only."
export const FILTER_SCOPE_LOCKED_BY_TAG_ON_PORTFOLIO_BASE_CAPTION = "Position tags and attributes only apply to your portfolio, so this filter applies to the portfolio only."
export const CONTRIBUTION_DISABLED_BY_FILTER_SCOPE_CAPTION = "Standalone only with Full benchmark."

const FILTER_SCOPE_HELPER_TEXT = "Filtered benchmark compares your slice with the same slice of the benchmark. Full benchmark compares your slice, as its own fund, with the whole benchmark."

const FILTER_SCOPE_OPTIONS = [
  {
    id: FILTER_SCOPE.PORTFOLIO_AND_BENCHMARK,
    primaryText: FILTER_SCOPE_LABELS[FILTER_SCOPE.PORTFOLIO_AND_BENCHMARK],
    secondaryText: "Applies filters to both the portfolio and the benchmark.",
  },
  {
    id: FILTER_SCOPE.PORTFOLIO_ONLY,
    primaryText: FILTER_SCOPE_LABELS[FILTER_SCOPE.PORTFOLIO_ONLY],
    secondaryText: "Your slice is measured as its own fund (Standalone) against the whole benchmark.",
  },
]

interface FilterScopeRadioGroupProps {
  value: string
  setValue: (value: string) => void
  hasBenchmark: boolean
  isUnavailable: boolean
  isLockedByFilter?: boolean
  baseType?: string
}

const BASE_TYPES_WITHOUT_TAGS = [BASE_TYPES.benchmark, BASE_TYPES.index, BASE_TYPES.etf, ...BASKET_TYPES]

function getFilterScopeLockedCaption(baseType: string | undefined): string {
  return baseType && BASE_TYPES_WITHOUT_TAGS.includes(baseType) ? FILTER_SCOPE_LOCKED_BY_TAG_ON_BENCHMARK_CAPTION : FILTER_SCOPE_LOCKED_BY_TAG_ON_PORTFOLIO_BASE_CAPTION
}

function getFilterScopeDisabledCaption(hasBenchmark: boolean, lockedByFilterCaption?: string): string | undefined {
  return hasBenchmark ? lockedByFilterCaption : FILTER_SCOPE_INACTIVE_CAPTION
}

export default function FilterScopeRadioGroup({ value, setValue, hasBenchmark, isUnavailable, isLockedByFilter = false, baseType }: FilterScopeRadioGroupProps) {
  const lockedByFilterCaption = isLockedByFilter ? getFilterScopeLockedCaption(baseType) : undefined
  const disabledCaption = isUnavailable ? undefined : getFilterScopeDisabledCaption(hasBenchmark, lockedByFilterCaption)

  return (
    <ListItemRadioGroup
      label="Compare against"
      value={value}
      setValue={setValue}
      options={FILTER_SCOPE_OPTIONS}
      disabled={isUnavailable || disabledCaption !== undefined}
      disabledTooltip={isUnavailable ? FILTER_SCOPE_UNAVAILABLE_TOOLTIP : undefined}
      helperText={disabledCaption ?? FILTER_SCOPE_HELPER_TEXT}
      classes={{ label: "filter-header" }}
    />
  )
}
